<template>
  <f7-page class="homepage-wrapper">
      <main id="homepage-main-content" role="main" tabindex="-1" class="homepage-main">
      <div class="main-content d-flex flex-column" :class="isFirstLoginTrue ? 'filter-blur-20px' : ''">
      <div class="content-wrapper flex-grow-1 d-flex">
        <h1 class="sr-only">{{ $t('Webheader.homepage') }}</h1>
        <b-container :class="{'w-60' : getCols < 5}" class="d-flex align-items-center justify-content-center main-page-positionning">
          <b-row align-h="start" :cols="getCols">
            <b-col v-for="(action, index) in data" :key="action.id">
              <b-container class="homeButton" :class="getColor(index)" @click="redirect(action.link)" fluid
                role="button"
                tabindex="0"
                :aria-label="$t(action.title)"
                @keydown.enter="redirect(action.link)"
                @keydown.space.prevent="redirect(action.link)">
                <b-row class="blocHome">
                  <b-col cols="9"><i :class="action.icon" class="homeButtonIcon fa" aria-hidden="true"></i></b-col>
                </b-row>
                <b-row class="d-flex-end h-50">
                  <b-col cols="9"><div class="w-100 fs-19px font-weight-bold text-white">{{ $t(action.title) }}</div></b-col>
                </b-row>
              </b-container>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <footer class="homepage-footer pb-10px mt-auto">
        <b-row>
          <b-col class="xs-12 text-center">
            <!-- Version mobile : liens empilés -->
            <div class="d-block d-md-none text-center">
              <div class="d-inline-flex align-items-center justify-content-center flex-wrap mb-2">
                <img class="logoStreammind" alt="Logo Streammind - Retour à la page d'accueil" :src="logoStreammind"></img>
                <span class="ml-1">{{ $t('common.copyright')}}</span> 
                <span>{{ version }}</span>
              </div>
              <div class="d-flex justify-content-center flex-wrap">
                <a
                  href="/sitemap"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-decoration-underline text-muted d-inline-block mx-2"
                  style="font-size: 11px; white-space: nowrap; line-height: 1.2;"
                  :aria-label="$t('footer.sitemap') + ' - ' + $t('common.opens_new_window')"
                >
                  {{ $t('footer.sitemap') }}
                </a>
                <a
                  href="/accessibilite"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-decoration-underline text-muted d-inline-block mx-2"
                  style="font-size: 11px; white-space: nowrap; line-height: 1.2;"
                  :aria-label="$t('footer.accessibility_notice_compliant') + ' - ' + $t('common.opens_new_window')"
                >
                  {{ $t('footer.accessibility_notice_compliant') }}
                </a>
              </div>
            </div>
            
            <!-- Version desktop : liens côte à côte -->
            <div class="d-none d-md-block position-relative text-center" style="min-height: 1.5rem;">
              <!-- Lien Plan du site -->
              <div
                class="text-left"
                style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); max-width: 150px;"
              >
                <a
                  href="/sitemap"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-decoration-underline text-muted d-inline-block"
                  style="font-size: 11px; white-space: normal; word-break: break-word; line-height: 1.2;"
                  :aria-label="$t('footer.sitemap') + ' - ' + $t('common.opens_new_window')"
                >
                  {{ $t('footer.sitemap') }}
                </a>
              </div>
              <!-- Bloc centré -->
              <div class="d-inline-flex align-items-center justify-content-center flex-wrap">
                <img class="logoStreammind" alt="Logo Streammind - Retour à la page d'accueil" :src="logoStreammind"></img>
                <span class="ml-1">{{ $t('common.copyright')}}</span> 
                <span>{{ version }}</span>
              </div>
              <!-- Lien accessibilité -->
              <div
                class="text-right"
                style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); max-width: 150px;"
              >
                <a
                  href="/accessibilite"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-decoration-underline text-muted d-inline-block"
                  style="font-size: 11px; white-space: normal; word-break: break-word; line-height: 1.2;"
                  :aria-label="$t('footer.accessibility_notice_compliant') + ' - ' + $t('common.opens_new_window')"
                >
                  {{ $t('footer.accessibility_notice_compliant') }}
                </a>
              </div>
            </div>
          </b-col>
        </b-row>
      </footer>
      </div>
      </main>
  </f7-page>
</template>

<script>
import buttonsData from '@/pages/user/data/homepageData.json'
import _ from 'lodash'
import Img from '../../assets/static/images/homepage/accueil.jpg'
import Logo from './../../assets/static/images/StreamMind_horizontal.png'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import DealPrudenceLogo from '../../assets/static/images/homepage/dealprudence_texte_seul.png'
import StreammindImage from './../../assets/static/images/streammind-text-seul.png'

/* import font awesome icon component */
/* import specific icons */
import pageTitleMixin from '@/mixins/pageTitleMixin'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Homepage',
  mixins: [pageTitleMixin],
  components: {
  },
  props: {
    context: {
      default: 'generic',
      type: String
    }
  },
  computed: {
    isFirstLoginTrue () {
      if (this.$engine.firstOn().user.getIsFirstLogin() === '1' || this.$engine.firstOn().user.get().isFirstLogin === '1') {
        return true
      } else {
        return false
      }
    },
    getCols () {
      // Sur mobile, limiter à 2 colonnes maximum
      const isMobile = this.windowWidth <= 576
      
      if (this.data.length < 5) {
        if (this.data.length < 2) {
          return '1'
        } else {
          return '2'
        }
      }
      
      // Sur mobile, maximum 2 colonnes même s'il y a plus de 5 éléments
      if (isMobile) {
        return '2'
      }
      
      return '3'
    }
  },
  data () {
    return {
      data: [],
      imgLogo: Logo,
      logoStreammind: StreammindImage,
      MrBgLogo: DealPrudenceLogo,
      nbButtons: 0,
      nbMaxItem: 3,
      nbMaxColor: 4,
      color: ['#4CD8C4','#F59655','#FA7C57','#EE89A6'],
      colors: ['0'],
      version: '',
      windowWidth: window.innerWidth
    }
  },
  created () {
    this.$bus.emit('isOnHomepage', true)
    this.$$('.homepageNavbar').removeClass('deleteNavBar')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: '',
      navTitle: '',
      returnUrl: ''
    })
    // Mettre à jour le titre de la page d'accueil
    this.updatePageTitle(this.$t('Webheader.homepage'))
    let availableButtons = []
    let that = this
    buttonsData.buttons.forEach(item => {
      if (!item.disabled && item.norm_right_SRTP && item.norm_right_HRTP && this.$engine.firstOn().user.getUserNorm()) {
        if (this.$engine.firstOn().user.getUserNorm() === '1' && this.hasRight(item.norm_right_SRTP)) {
          that.getCardClass
          item.class = that.getCardClass(item) + ' ' + item.class
          availableButtons.push(item)
        } else if (this.$engine.firstOn().user.getUserNorm() === '2' && this.hasRight(item.norm_right_HRTP)) {
          that.getCardClass
          item.class = that.getCardClass(item) + ' ' + item.class
          availableButtons.push(item)
        }
      } else if (!item.disabled && !item.hidden && this.hasRight(item.right)) {
        that.getCardClass
        item.class = that.getCardClass(item) + ' ' + item.class
        availableButtons.push(item)
      }
    })
    let dataCopy = availableButtons.filter(elem => that.hasRight(elem.right))
    let settingsFound = false
    let settingsRtpFound = false
    dataCopy.forEach((item => {
      if (item.id === 3) {
        settingsFound = true
      }

      if (item.id === 4) {
        settingsRtpFound = true
      }
    }))

    this.data = dataCopy
    if (this.data.length < this.nbMaxItem) {
      this.nbMaxItem = this.data.length
    }
    if (this.$engine.firstOn().versionAPI) {
      this.version = 'Version ' + this.$engine.firstOn().versionAPI
    } else {
      this.$engine.firstOn().getApiVersion()
      .then(resp => {
        if (resp.data.version) {
          that.$engine.firstOn().versionAPI = resp.data.version
          if (that.$engine.firstOn().versionAPI) {
            that.version = 'Version ' + that.$engine.firstOn().versionAPI
          }
        }
      })
      .catch(err => {
        errorMessageAlert(err, that, true)
      })
    }
  },
  mounted () {
    this.tryRedirect()
    // Ajouter un listener pour le redimensionnement de fenêtre
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // Nettoyer le listener
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      // Utiliser un debounce pour éviter trop d'appels
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout)
      }
      this.resizeTimeout = setTimeout(() => {
        this.windowWidth = window.innerWidth
      }, 150)
    },
    tryRedirect () {
      let previousPage = this.$f7.getCurrentView().history[this.$f7.getCurrentView().history.length - 1]
      if (previousPage === '/login/') {
        this.$bus.emit('refresh-cache-menu')
      }
    },
    getColor(index) {
      // Récupérer la couleur en fonction de l'index
      return 'card-color-' + (index % this.color.length)
    },
    getCardClass (button) {
      this.nbButtons++
      return ('homeCardBody-' + ((this.nbButtons % this.nbMaxColor) + 1))
    },
    hasRight (right) {
      return this.$engine.firstOn().rights.rightIs(right, true)
    },
    redirect (url) {
      this.$bus.$emit('switch-selected-menu', url)
      loadPage(this, { url: url })
    }
  }
}
</script>
<style scoped>

/* Override f7-page pour la homepage */
.f7-page.homepage-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Assurer que le contenu de f7-page prend toute la hauteur */
.homepage-wrapper :deep(.page-content) {
  height: 100%;
  overflow-y: auto;
}

/* Main content avec flexbox */
.homepage-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.main-content {
  background-color: #FFFFFF;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

/* Content wrapper prend tout l'espace disponible */
.content-wrapper {
  flex: 1;
  display: flex;
}

/* Footer toujours en bas */
.homepage-footer {
  flex-shrink: 0;
  margin-top: auto;
}

@media (max-width:991px) {
  .homepage-main {
    min-height: calc(100% - 44px);
  }
}

</style>
